"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _member = require("@/api/member/member");
var _upgradeConfiguration = require("@/api/hierarchicalCommissionAllocation/upgradeConfiguration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      itemKey: 'invitation_Code_Module',
      form: {
        money: '',
        radio: 1,
        level: ''
      },
      options: [],
      rules: {}
    };
  },
  created: function created() {
    this.memberQueryMemberGradeApi();
  },
  methods: {
    memberQueryMemberGradeApi: function memberQueryMemberGradeApi() {
      var _this = this;
      (0, _member.memberQueryMemberGradeApi)().then(function (res) {
        _this.options = res.data;
      }).then(function () {
        _this.getSetting();
      }).catch(function () {
        _this.getSetting();
      });
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.$confirm('是否保存此设置？', '提示', {
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(function () {
            _this2.saveSetting();
          });
        } else {
          _this2.$message.error('请填写所有必填项');
          return false;
        }
      });
    },
    handleReset: function handleReset() {
      this.$refs.form.resetFields();
    },
    getSetting: function () {
      var _getSetting2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                itemKey: this.itemKey
              };
              _context.n = 1;
              return (0, _upgradeConfiguration.getSetting)(params);
            case 1:
              res = _context.v;
              if (res.data !== '') {
                this.form = (0, _objectSpread2.default)({}, JSON.parse(res.data));
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getSetting() {
        return _getSetting2.apply(this, arguments);
      }
      return getSetting;
    }(),
    saveSetting: function () {
      var _saveSetting2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, response, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                itemKey: this.itemKey,
                itemValue: JSON.stringify(this.form)
              };
              _context2.n = 1;
              return (0, _upgradeConfiguration.saveSetting)(params);
            case 1:
              response = _context2.v;
              if (response.code === 0) {
                this.$message.success('保存成功');
                this.getSetting();
              } else {
                this.$message.error(response.msg || '保存失败');
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.$message.error('保存失败');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function saveSetting() {
        return _saveSetting2.apply(this, arguments);
      }
      return saveSetting;
    }()
  }
};